// Анимация «навык летит в учебный план».
// Копия чипа летит по дуге от места нажатия к чипу в полосе плана (или к «Показать все»,
// если чип скрыт в свёрнутой полосе, или к строке шагов, если полоса уехала вверх).
// Чип в плане появляется в момент приземления: PlanChip берёт isFresh() при монтировании.

const norm = (name) => (name || '').trim().toLowerCase()
// навык → через сколько мс он «приземлится» (для задержки появления чипа в плане)
const fresh = new Map()
export const FLIGHT_MS = 700

export const freshDelay = (name) => (fresh.has(norm(name)) ? fresh.get(norm(name)) : null)

const markFresh = (name, landAt) => {
  const key = norm(name)
  fresh.set(key, landAt)
  setTimeout(() => fresh.delete(key), landAt + 2000)
}

const visible = (rect) => rect.width > 0 && rect.bottom > 0 && rect.top < window.innerHeight

const findTarget = (name) => {
  const chip = document.querySelector(
    `[data-plan-chip="${window.CSS && CSS.escape ? CSS.escape(norm(name)) : norm(name)}"]`
  )
  if (chip) {
    const r = chip.getBoundingClientRect()
    const box = chip.parentElement && chip.parentElement.getBoundingClientRect()
    if (visible(r) && (!box || r.bottom <= box.bottom + 2)) return { el: chip, rect: r }
  }
  const more = document.querySelector('[data-plan-more]')
  if (more) {
    const r = more.getBoundingClientRect()
    if (visible(r)) return { el: more, rect: r }
  }
  const zone = document.querySelector('[data-gen-static]')
  if (zone) {
    const r = zone.getBoundingClientRect()
    return { el: null, rect: { left: r.left + 40, top: Math.max(r.top, 0) + 6, width: 120, height: 36 } }
  }
  return null
}

const reduced = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

export function flyToPlan(fromEl, name, delay = 0) {
  const animated = !!fromEl && !!document.body.animate && !reduced()
  markFresh(name, animated ? delay + FLIGHT_MS - 80 : 0)
  if (!animated) return
  const from = fromEl.getBoundingClientRect()
  if (!from.width) return

  const ghost = document.createElement('div')
  ghost.textContent = name
  Object.assign(ghost.style, {
    position: 'fixed',
    left: `${from.left}px`,
    top: `${from.top}px`,
    height: `${from.height}px`,
    display: 'flex',
    alignItems: 'center',
    padding: '0 14px',
    borderRadius: '12px',
    background: '#3077ff',
    color: '#fff',
    fontSize: '15px',
    fontWeight: 500,
    fontFamily: getComputedStyle(fromEl).fontFamily,
    whiteSpace: 'nowrap',
    boxShadow: '0 10px 30px rgba(48, 119, 255, 0.45)',
    zIndex: 10000,
    pointerEvents: 'none',
    opacity: 0,
  })

  setTimeout(() => {
    document.body.appendChild(ghost)
    // ждём, пока чип появится в полосе плана (оптимистичное обновление списка)
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        const target = findTarget(name)
        if (!target) return ghost.remove()
        const g = ghost.getBoundingClientRect()
        const dx = target.rect.left + target.rect.width / 2 - (g.left + g.width / 2)
        const dy = target.rect.top + target.rect.height / 2 - (g.top + g.height / 2)
        const lift = Math.min(120, Math.abs(dy) * 0.35 + 40)
        const anim = ghost.animate(
          [
            { transform: 'translate(0, 0) scale(1)', opacity: 1 },
            { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - lift}px) scale(1.06)`, opacity: 1, offset: 0.45 },
            { transform: `translate(${dx}px, ${dy}px) scale(0.75)`, opacity: 0.15 },
          ],
          { duration: FLIGHT_MS, easing: 'cubic-bezier(.45, 0, .25, 1)', fill: 'forwards' }
        )
        anim.onfinish = () => {
          ghost.remove()
          if (target.el && target.el.hasAttribute('data-plan-more'))
            target.el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.15)' }, { transform: 'scale(1)' }], {
              duration: 350,
            })
        }
      })
    )
  }, delay)
}
